import {
  BannerClickType,
  BannerPosition,
  BannerType,
} from '../../common/components/banner/models';
import {
  ConeProduct,
  ConeUserAccessPermissions,
  ConeUserRole,
} from '../../common/constants/common';

export type UserMeta = {
  org_id: string;
  external_id?: string;
  id: string;
  is_owner: boolean;
  locale?: string;
  currently_due?: string[];
  eventually_due?: string[];
  onboarding: {
    skipped: boolean;
    done: boolean;
  };
  products?: ConeProduct[];
  roles?: ConeUserRole[];
  subscriber_id?: string;
  suprsend_access_token?: string;
  org_permissions: ConeUserAccessPermissions[];
  chat_user_hash?: string;
  currency: string;
  timezone: string;
  referral_id?: string;
};

export enum OrgRegions {
  India = 'india',
}

export enum InfoBannerMap {
  Proposal = 'proposal',
  Client = 'client',
  Deal = 'deal',
  Work = 'work',
  Contact = 'contact',
  Services = 'services',
  Payments = 'payments',
  Settings_Branding = 'settings_branding',
  Settings_Reminders = 'settings_reminders',
  Settings_Integrations = 'settings_integrations',
  Settings_Workflow = 'settings_workflow',
  Time = 'time',
  Invoice = 'invoice',
}

export enum UserFeatureFlag {
  SUBSCRIPTION_ENABLED = 'feature-flag.subscriptions_enabled',
  BILLING_ENABLED = 'feature-flag.billing_enabled',
  DEALS_ENABLED = 'feature-flag.deals',
  CUSTOM_ROLES_ENABLED = 'feature-flag.custom_roles',
  OUTLOOK_ENABLED = 'feature-flag.outlook',
  AUTOMATIC_PAYMENT_ENABLED = 'feature-flag.automatic-payments',
  AUTOMATIC_INVOICES_ENABLED = 'feature-flag.automatic-invoices',
  CLIENT_REMINDERS_ENABLED = 'feature-flag.client-reminders',
  CLIENT_PORTAL_ENABLED = 'feature-flag.client-portal',
  CLIENT_REQUEST_ENABLED = 'feature-flag.client-requests',
  CLIENT_PROJECT_STATUS_ENABLED = 'feature-flag.custom-project-status',
  DOCUMENT_SYSTEM_ENABLED = 'feature-flag.documents-system',
  EMAIL_MANAGEMENT_ENABLED = 'feature-flag.email-management',
  PROPOSAL_ENABLED = 'feature-flag.proposals',
  RECURRING_PROJECTS_ENABLED = 'feature-flag.recurring-projects',
  REPORTS_ENABLED = 'feature-flag.reports',
  STORAGE_INTEGRATION_ENABLED = 'feature-flag.storage-integration',
  ZAPIER_ENABLED = 'feature-flag.zapier',
  CUSTOM_EMAIL_ENABLED = 'feature-flag.custom-email-enabled',
  CONE_FOOTER_ENABLED = 'feature-flag.cone-footer',
  SURCHARGE = 'feature-flag.surcharge',
  PAYMENT_RECONCILE = 'feature-flag.payment-reconcile',
}

export type BannerDto = {
  banner_position: BannerPosition;
  description: string;
  id: string;
  is_not_dismissible: boolean;
  page_id: string;
  primary_button_click_type?: BannerClickType;
  primary_button_on_click?: string;
  primary_button_text?: string;
  secondary_button_click_type?: BannerClickType;
  secondary_button_on_click?: string;
  secondary_button_text?: string;
  title: string;
  type: BannerType;
};

export type UserWorkPermissions = {
  permissions: {
    [K in
      | `Project:${string}`
      | `Task:${string}`
      | `TimeEntry:${string}`]: ConeUserAccessPermissions[];
  };
};

export type TaxSymbolsResponse = {
  country: string;
  description: string;
  enum: string;
  example: string;
};

export type TaxSymbolsResponseTransformed = {
  enum: string;
  example: string;
  description: string;
  countries: string[];
};
